import { makeNumberRenderer } from 'App/data-export/valueTypeRenderers/renderers/_utils/makeNumberRenderer'
import type { valueTypeRenderers } from 'App/data-export/valueTypeRenderers/valueTypeRenderers'
import { unitConverter } from 'utils/unitConverter/unitConverter'

export const temperature_BELOW: typeof valueTypeRenderers.temperature_BELOW = {
  label: () => unitConverter.temperatureBelowCanopy().titleWithoutUnit(),
  point: () =>
    makeNumberRenderer({
      baseLabel: unitConverter.temperatureBelowCanopy().title(),
      render: (n) => unitConverter.temperatureBelowCanopy(n).valueAsString(),
    }),
}
